import {
  MealCountStatus,
  IMealCountKey,
  ServingLine } from '@/models'
import { UserInfo } from '@/store';
import { mcDate } from '@/utils'
import { Guid } from 'guid-typescript';
import moment from "moment";

/** TODO: Make all count lookups everywhere use these (fake) 'extension' methods. They account for all variants of Meal Type spelling and Service Date formats. */
export const mcCounts = {
  matchMealCountKey(l: IMealCountKey, r: IMealCountKey) {
    return l.siteId == r.siteId
      && l.programId == r.programId
      && l.mealTypeId.toUpperCase() == r.mealTypeId.toUpperCase()
      && mcDate.toShortDate(l.mealServiceDate) == mcDate.toShortDate(r.mealServiceDate);
  },

  matchCountStatuses(l: MealCountStatus, r: MealCountStatus) {
    return l.siteId == r.siteId
      && l.programId == r.programId
      && l.mealTypeId.toUpperCase() == r.mealTypeId.toUpperCase()
      && mcDate.toShortDate(l.mealServiceDate) == mcDate.toShortDate(r.mealServiceDate);
  },

  /**
   * Find serving lines that are served by the given userId
   * @param servingLines The serving lines to filter
   * @param userId The user we want to find
   * @returns The first servingLine with matching servedBy userId. If servingLines is falsy, returns undefined
   */
  findServingLine(servingLines: ServingLine[], userId: number) {
    let result: ServingLine | undefined = undefined;
    if (servingLines) {
      result = servingLines.find(o => o.servedBy === userId && o.mergedIntoTrackingId === undefined);
    }
    return result;
  },

  /**
   * Find serving lines that are NOT served by the given userId
   * @param servingLines The serving lines to filter
   * @param userId The user we DON'T want to find
   * @returns An array of serving lines that don't have a matching servedBy userId. If servingLines is falsy, returns undefined
   */
  findServingLinesForOthers(servingLines: ServingLine[], userId: number) {
    let result: ServingLine[] | undefined = undefined;
    if (servingLines) {
      result = servingLines.filter(o => o.servedBy !== userId && o.mergedIntoTrackingId === undefined);
    }
    return result;
  },

  getNewServingLine(user: UserInfo) {
    const date = moment.utc().format();
    return new ServingLine(
      Guid.create().toString(),
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              false,
              user.userId,
              user.firstName,
              user.lastName,
              date,
              date);
  }
}
